<template>
    <v-expansion-panels accordion>
        <v-expansion-panel>
            <v-expansion-panel-header>
                <template v-slot:default="{ open }">
                    <v-row no-gutters>
                        <v-col cols="4">
                            {{ $t("billing-information") }}
                        </v-col>
                        <v-col cols="8" class="text--secondary">
                            <v-fade-transition leave-absolute>
                                <span v-if="open">
                                    {{ $t("billing-information-fields") }}
                                </span>
                            </v-fade-transition>
                        </v-col>
                    </v-row>
                </template>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
                <validation-observer ref="form">
                    <validation-provider
                        v-slot="{ errors }"
                        name="lastname"
                        rules="required|max:255"
                    >
                        <v-text-field
                            v-model="billingLastname"
                            placeholder="Smith"
                            :error-messages="errors"
                        ></v-text-field>
                    </validation-provider>

                    <validation-provider
                        v-slot="{ errors }"
                        name="firstname"
                        rules="required|max:255"
                    >
                        <v-text-field
                            v-model="billingFirstname"
                            placeholder="John"
                            :error-messages="errors"
                        ></v-text-field>
                    </validation-provider>

                    <validation-provider
                        v-slot="{ errors }"
                        name="email"
                        rules="required|email"
                    >
                        <v-text-field
                            v-model="billingEmail"
                            placeholder="JohnSmith@google.com"
                            :error-messages="errors"
                        ></v-text-field>
                    </validation-provider>

                    <v-btn
                        color="primary"
                        :loading="loading"
                        text
                        @click.stop="save"
                        >{{ $t("Save") }}</v-btn
                    >
                </validation-observer>
            </v-expansion-panel-content>
        </v-expansion-panel>
    </v-expansion-panels>
</template>

<script>
import { ValidationObserver, ValidationProvider } from "vee-validate";
import snackbar from "@/mixins/snackbar";

export default {
    name: "BillingInformationExpansionPanel",
    props: ["entity"],
    components: { ValidationObserver, ValidationProvider },
    mixins: [snackbar],
    data() {
        return {
            billingLastname: this.entity.billing_lastname,
            billingFirstname: this.entity.billing_firstname,
            billingEmail: this.entity.billing_email,
            loading: false
        };
    },
    methods: {
        save() {
            this.$refs.form.validate().then(success => {
                if (!success) {
                    return;
                }
                this.loading = true;
                this.$store
                    .dispatch("entities/saveBillingInformations", {
                        entityId: this.entity.id,
                        billingLastname: this.billingLastname,
                        billingFirstname: this.billingFirstname,
                        billingEmail: this.billingEmail
                    })
                    .then(() => {
                        this.loading = false;
                        this.snackbar(
                            "success",
                            this.$t(
                                "snackbar-message-billing-information.updated"
                            )
                        );
                    })
                    .catch(() => {
                        this.snackbar(
                            "error",
                            this.$t(
                                "snackbar-message-billing-information.error"
                            )
                        );
                    });
            });
        }
    }
};
</script>
